/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationChartLabel
 */
export interface EvaluationChartLabel {
    /**
     * 
     * @type {number}
     * @memberof EvaluationChartLabel
     */
    floatValue?: number;
    /**
     * 
     * @type {string}
     * @memberof EvaluationChartLabel
     */
    metricName: string;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationChartLabel
     */
    present: boolean;
    /**
     * 
     * @type {string}
     * @memberof EvaluationChartLabel
     */
    stringValue?: string;
    /**
     * 
     * @type {string}
     * @memberof EvaluationChartLabel
     */
    type: EvaluationChartLabelTypeEnum;
}


/**
 * @export
 */
export const EvaluationChartLabelTypeEnum = {
    Float64: 'FLOAT64',
    String: 'STRING'
} as const;
export type EvaluationChartLabelTypeEnum = typeof EvaluationChartLabelTypeEnum[keyof typeof EvaluationChartLabelTypeEnum];


/**
 * Check if a given object implements the EvaluationChartLabel interface.
 */
export function instanceOfEvaluationChartLabel(value: object): value is EvaluationChartLabel {
    if (!('metricName' in value) || value['metricName'] === undefined) return false;
    if (!('present' in value) || value['present'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function EvaluationChartLabelFromJSON(json: any): EvaluationChartLabel {
    return EvaluationChartLabelFromJSONTyped(json, false);
}

export function EvaluationChartLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationChartLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'floatValue': json['floatValue'] == null ? undefined : json['floatValue'],
        'metricName': json['metricName'],
        'present': json['present'],
        'stringValue': json['stringValue'] == null ? undefined : json['stringValue'],
        'type': json['type'],
    };
}

export function EvaluationChartLabelToJSON(value?: EvaluationChartLabel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'floatValue': value['floatValue'],
        'metricName': value['metricName'],
        'present': value['present'],
        'stringValue': value['stringValue'],
        'type': value['type'],
    };
}

